<template>
    <svg viewBox="0 0 8 8" class="icon">
        <use :xlink:href="href"></use>' +
    </svg>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'OpenIcon',
        props: { name: String },
        data() {
            return {
                // href: '/open-iconic/open-iconic.svg#' + this.name
            }
        },
        computed: {
            href() {
                return '/open-iconic/open-iconic.svg#' + this.name
            }
        }
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

    svg {
        //vertical-align: initial;
    }

    svg.icon {
        width:20px;
        height:20px;
        fill:#17a2b8;

        &.disabled {
            fill:#ccc !important;
        }
    }

    .btn {
        svg.icon {
            /*width:12px;*/
            /*height:12px;*/
        }
        use {}
    }
</style>
